









































































































































































































































































































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import DateTimeUtils from '@/lib/dateTimeUtils';
import UpdateJobWorkerInterviewDetailsRequest from '@/models/JobWorkerInterviews/UpdateJobWorkerInterviewDetailsRequest'
import ContactLocationDto from '@/models/ContactLocations/ContactLocationDto';
import ajax from '@/lib/ajax';
import JobWorkerInterviewDto from '@/models/JobWorkerInterviews/JobWorkerInterviewDto';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import { AppModule } from '@/store/modules/app';
import UpdateJobWorkerInterviewDetailsViewModel from '@/models/JobWorkerInterviews/UpdateJobWorkerInterviewDetailsViewModel';
import ListUtils from '@/lib/listUtils';
import InPersonInterviewAddressType from '@/models/JobWorkerInterviews/InPersonInterviewAddressType';
import JobWorkerInterviewType from '@/models/JobWorkerInterviews/JobWorkerInterviewType';
import CompanyAddressDto from '@/models/CompanyAddresses/CompanyAddressDto';
import LocationDto from '@/models/Locations/LocationDto';
import AddressUtils from '@/lib/addressUtils';
import JobWorkerStatus from '@/models/JobWorkers/JobWorkerStatus';

@Component({
    name: 'JobWorkerInterviewDetailsEdit'
})
export default class extends GiganautVueDialog {
 
    jobWorkerInterviewType = JobWorkerInterviewType;
    inPersonInterviewAddressType = InPersonInterviewAddressType;

    @Prop({required: true})
    jobWorkerInterview: JobWorkerInterviewDto;
    @Prop({required: true})
    jobWorkerStatus: JobWorkerStatus;
    contactLocations: ContactLocationDto[] = [ new ContactLocationDto() ];
    companyAddresses: CompanyAddressDto[] = [];
    locations: LocationDto[] = [];
    vm: UpdateJobWorkerInterviewDetailsViewModel = new UpdateJobWorkerInterviewDetailsViewModel();
    request: UpdateJobWorkerInterviewDetailsRequest;

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.vm = new UpdateJobWorkerInterviewDetailsViewModel();
            this.vm.jobWorkerInterviewId = this.jobWorkerInterview.id;
            this.vm.updatedAt = this.jobWorkerInterview.updatedAt;
            this.vm.date = DateTimeUtils.toYYMMDD(new Date(this.jobWorkerInterview.startAt))
            this.vm.startAtTime = new Date(this.jobWorkerInterview.startAt).toLocaleTimeString();
            this.vm.endAtTime = new Date(this.jobWorkerInterview.endAt).toLocaleTimeString();

            //Load list data
            await ajax.get(`/api/v1/agency/locations/${JobDetailsModule.currentJob.locationId}/contacts`)
            .then(response => {
                this.contactLocations = response.data;
            })
            .catch(error => {
                AppModule.handleApiError(error);
            })
            await ajax.get(`/api/v1/agency/companies/${JobDetailsModule.currentJob.companyId}/addresses`)
            .then(response => {
                this.companyAddresses = response.data;
            })
            .catch(error => {
                AppModule.handleApiError(error);
            })
              await ajax.get(`/api/v1/agency/companies/${JobDetailsModule.currentJob.companyId}/locations`)
            .then(response => {
                this.locations = response.data;
            })
            .catch(error => {
                AppModule.handleApiError(error);
            })


            this.vm.selectedContactLocation = this.contactLocations.find((contactLocationToFind: ContactLocationDto) => contactLocationToFind.contactId === this.jobWorkerInterview.contactId);
            this.vm.type = this.jobWorkerInterview.type;

            if (this.vm.type === JobWorkerInterviewType.InPerson){
                this.vm.inPersonAddressType = this.jobWorkerInterview.inPersonAddressType;
                if (this.vm.inPersonAddressType === InPersonInterviewAddressType.CompanyAddress)
                {
                    this.vm.selectedCompanyAddress = this.companyAddresses.find((companyAddressToFind: CompanyAddressDto) => companyAddressToFind.id === this.jobWorkerInterview.companyAddressId);
                } else if (this.vm.inPersonAddressType === InPersonInterviewAddressType.OtherLocation) {
                    this.vm.selectedOtherLocation = this.locations.find((locationToFind: LocationDto) => locationToFind.id === this.jobWorkerInterview.interviewLocationId);
                } else if (this.vm.inPersonAddressType === InPersonInterviewAddressType.OtherAddress) {
                    this.vm.buildingNameNumber = this.jobWorkerInterview.buildingNameNumber;
                    this.vm.streetRoadBlock = this.jobWorkerInterview.streetRoadBlock;
                    this.vm.locality = this.jobWorkerInterview.locality;
                    this.vm.cityTown = this.jobWorkerInterview.cityTown;
                    this.vm.stateProvinceRegion = this.jobWorkerInterview.stateProvinceRegion;
                    this.vm.postZipCode = this.jobWorkerInterview.postZipCode;
                    this.vm.countryCode = this.jobWorkerInterview.countryCode;
                    this.vm.geometry = this.jobWorkerInterview.geometry
                    this.vm.isExactGeo = this.jobWorkerInterview.isExactGeo;
                }
            }
            this.vm.workerInstructions = this.jobWorkerInterview.workerInstructions;
            this.vm.contactInstructions = this.jobWorkerInterview.contactInstructions;
        }
    }

    get loading() {
        return JobDetailsModule.loadingDialog;
    }

    get disabled() {
		if (this.jobWorkerStatus === JobWorkerStatus.InterviewOne || this.jobWorkerStatus === JobWorkerStatus.InterviewTwo) {
            return false;
        }
        return true;
	}

    get interviewTypeOptions() {
        return ListUtils.jobWorkerInterviewTypeOptions();
    }

    get inPersonInterviewAddressTypeOptions() {
        return ListUtils.inPersonInterviewAddressTypeOptions();
    }

    get isoCountries() {
        return AddressUtils.isoCountries();
    }

      async getAddressData(addressData: any, placeData: any) {
      this.vm.buildingNameNumber = addressData.street_number ? addressData.street_number:'';
      this.vm.streetRoadBlock = addressData.route ? addressData.route:'';
      this.vm.locality = addressData.locality ? addressData.locality:'';
      //Pick out the postal town
      for (let index = 0; index < placeData.address_components.length; index++) {
        const element = placeData.address_components[index];
        if (element.types[0] === "postal_town"){
          this.vm.cityTown = element.long_name;
        }
        
      }
      //Pick out the country code
      for (let index = 0; index < placeData.address_components.length; index++) {
        const element = placeData.address_components[index];
        const isoCountriesLocal = this.isoCountries;
        if (element.types[0] === "country"){
          for (let countryIndex = 0; countryIndex < isoCountriesLocal.length; countryIndex++) {
            if (isoCountriesLocal[countryIndex].code === element.short_name) {
              this.vm.country = isoCountriesLocal[countryIndex];
            }
          }
        }   
      }
      //this.entity.address.countryCode = 'GB';
      this.vm.stateProvinceRegion = addressData.administrative_area_level_2 ? addressData.administrative_area_level_2:'';
      this.vm.postZipCode = addressData.postal_code ? addressData.postal_code:'';
      this.vm.geometry.lat = addressData.latitude;
      this.vm.geometry.lng = addressData.longitude;
  }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        this.vm.jobWorkerInterviewId = this.jobWorkerInterview.id;
        this.vm.updatedAt = this.jobWorkerInterview.updatedAt;
        await JobDetailsModule.editJobWorkerInterviewDetails(this.vm);
        this.dialog = false;
    }
}
